const Rulings = require('./rulings');
const FormatLegality = require('./format-legality');
const template = require('./index.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	const playFormats = [
		'commander',
		'standard',
		'modern',
		'legacy',
		'vintage',
		'duel'
	];

	const legalities = [
		'Legal',
		'Restricted',
		'Future',
		'Not Legal',
		'Banned',
	];

	var formatIndex = {};

	var resetLegalities = function() {
		_t.legality = [];
		for (i in playFormats) {
			var format = playFormats[i];
			var legality = new FormatLegality({
				name: format,
				legality: 'Legal'
			});
			_t.legality.push(legality);
			formatIndex[format] = legality;
		}
	};

	var restrictBy = function(legality) {
		playFormats.forEach(function(format) {
			var cardLegality = legality[format] || 'Not Legal';
			var deckLegality = formatIndex[format];
			var cardRestrictiveness = legalities.indexOf(cardLegality);
			var deckRestrictiveness = legalities.indexOf(deckLegality.legality);
			if (cardRestrictiveness > deckRestrictiveness) {
				deckLegality.legality = cardLegality;
			}
		});
	};

	this.assess = function(cards) {
		resetLegalities();
		var rules = cards.map(function(card) {
			ruling = new Rulings({card: card, playFormats: playFormats});
			if (ruling.card.legalities) {
				restrictBy(ruling.card.legalities);
			} else {
				on(ruling, 'legalities').then(restrictBy);
			}
			return ruling;
		});
		rules.sort(function(a,b) {
			return a.card.name > b.card.name ? 1 : -1;
		});
		this.rules = rules;
	};
});
